$(document).ready(function () {
    // Validation
    $('#ReportConcernForm').validate({
        rules: {
            type: {
                required: true,
            },
            message: {
                required: true,
                minlength: 15,
            },
        },
        type: {
            type: {
                required: 'Please select the nature of your concern',
            },
            message: {
                required: 'Please give a full description of your concern',
                minlength: 'Your concern details must be a minimum of 15 characters',
            },
        },
        submitHandler: function (form) {
            form.submit();
        },
    });

    $('.nameinconcern, .message, .signature, .anonymity').hide();
    $('input[type="radio"]').click(function () {
        if ($(this).attr('value') == 'fellow-student') {
            $('.nameinconcern, .message, .signature, .anonymity').show();
            $('.maininconcernlabel').empty().append('Fellow Student Name');
        }
        if ($(this).attr('value') == 'staff') {
            $('.nameinconcern, .message, .signature, .anonymity').show();
            $('.maininconcernlabel').empty().append('Member of Staff Name');
        }
        if ($(this).attr('value') == 'patient-care') {
            $('.nameinconcern').hide();
            $('.message, .signature, .anonymity').show();
        }
    });

    var concernAnonCheckbox = document.getElementById('anonymity');
    $('input[name="anonymity"]').click(function () {
        if (concernAnonCheckbox.checked == true) {
            $('.signature').hide();
        }
        if (concernAnonCheckbox.checked == false) {
            $('.signature').show();
        }
    });
});
